import { render, staticRenderFns } from "./ShowCompanyDemo.vue?vue&type=template&id=d9780260&"
import script from "./ShowCompanyDemo.vue?vue&type=script&lang=js&"
export * from "./ShowCompanyDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default})
